import { isBelowDesktop as _isBelowDesktop } from "../utils/breakpoints";

const LandingpageHeroMedia = (function () {
  const $heroImageWrapper = $(".hero-image-wrapper.js-image-wrapper");
  const $heroVideoWrapper = $(".hero-block .js-video-wrapper");
  const $heroImage = $(".hero-image-wrapper.js-image-wrapper .js-hero-image");
  const $heroVideo = $(
    ".hero-block .js-hero-video",
  ) as JQuery<HTMLVideoElement>;
  const $heroVideoSource = $heroVideo.find("source");
  const $heroVideoButtonsWrapper = $(".hero-block .js-video-buttons-wrapper");
  const $heroVideoPauseBtn = $(".hero-block .js-pause-hero-video");
  const $heroVideoPlayBtn = $(".hero-block .js-play-hero-video");

  let isBelowDesktop = _isBelowDesktop();

  $(window).on("resize", function () {
    if (isBelowDesktop !== _isBelowDesktop()) {
      // iOS fires resize event on scroll
      isBelowDesktop = _isBelowDesktop();
      initHeroMedia();
    }
  });

  function init() {
    initHeroMedia();
    initPlayPauseButtons();
  }

  function initHeroMedia() {
    initHeroImage();
    initHeroVideo();
  }

  function initHeroImage() {
    const useImageOnMobile = $heroImage.data("useMobile") === "True";
    const useImageOnDesktop = $heroImage.data("useDesktop") === "True";

    if (isBelowDesktop && useImageOnMobile) {
      setupImage("altMobile", "srcMobile");
    } else if (!isBelowDesktop && useImageOnDesktop) {
      setupImage("altDesktop", "srcDesktop");
    }
  }

  function initHeroVideo() {
    const useVideoOnMobile = $heroVideo.data("useMobile") === "True";
    const useVideoOnDesktop = $heroVideo.data("useDesktop") === "True";
    if (!isBelowDesktop && useVideoOnMobile) {
      $heroVideoButtonsWrapper.hide(0);
    } else if (isBelowDesktop && useVideoOnMobile) {
      $heroVideoButtonsWrapper.show(0);
    }
    if (isBelowDesktop && useVideoOnMobile) {
      setupVideo("posterMobile", "titleMobile", "srcMobile");
    } else if (!isBelowDesktop && useVideoOnDesktop) {
      setupVideo("posterDesktop", "titleDesktop", "srcDesktop");
    }
  }

  function setupImage(altDataAttr: string, srcDataAttr: string) {
    $heroImage.attr("alt", $heroImage.data(altDataAttr));
    $heroImage.attr("src", $heroImage.data(srcDataAttr));

    $heroVideoWrapper.hide(0);
    $heroVideoButtonsWrapper.hide(0);
    $heroImageWrapper.show(0);
  }

  function setupVideo(
    posterDataAttr: string,
    titleDataAttr: string,
    srcDataAttr: string,
  ) {
    $heroVideo.attr("poster", $heroVideo.data(posterDataAttr));
    $heroVideo.attr("title", $heroVideo.data(titleDataAttr));
    $heroVideoSource.attr("src", $heroVideoSource.data(srcDataAttr));

    $heroImageWrapper.hide(0);
    $heroVideoWrapper.show(0);
    $heroVideoButtonsWrapper.show(0);

    $heroVideo.get(0)?.load();

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      $heroVideo.get(0)?.setAttribute('autoplay', '');
      $heroVideo.get(0)?.play();
      $heroVideoPlayBtn.hide();
      $heroVideoPauseBtn.show();
    }

    $heroVideo.get(0)?.addEventListener("ended", handleEnded, false);
  }

  function handleEnded() {
    $heroVideoPauseBtn.hide();
    $heroVideoPlayBtn.show();
  }

  function initPlayPauseButtons() {
    $heroVideoPauseBtn.on("click", function () {
      $heroVideo.get(0)?.pause();
      $heroVideoPauseBtn.hide();
      $heroVideoPlayBtn.show().focus();
    });

    $heroVideoPlayBtn.on("click", function () {
      $heroVideo.get(0)?.play();
      $heroVideoPlayBtn.hide();
      $heroVideoPauseBtn.show().focus();
    });
  }

  return {
    init,
  };
})();

export default LandingpageHeroMedia;
